import { PageHeader } from "@shared/components/PageHeader";
import { Card } from "@shared/ui/card";
import { MetersTable } from "./list";
import { useGetMetersCount, useGetRouteData } from "@features/mx/routeManagement/hooks";
import { useParams, useSearchParams } from "react-router-dom";

export const MetersTab = () => {
  const { route_id } = useParams();
  const [searchParams] = useSearchParams();

  // Extract filters from URL
  const page = Number(searchParams.get("page") || "1");
  const search = searchParams.get("search") || "";
  const filterStatus = searchParams.get("filter_status") || "all";
  const readingStatus = searchParams.get("reading_status") || "all";
  const meterType = searchParams.get("meter_type") || "all";

  const { data: routeDetailsData } = useGetRouteData(route_id);
  
const { data: metersApiResponse } = useGetMetersCount(
  route_id,
  page,
  meterType,
  filterStatus,
  readingStatus,
  search
);

  return (
    <Card className="shadow-sm">
      <div className="space-y-6">
        <PageHeader title="Meters" />
        <MetersTable meterData={metersApiResponse} />
      </div>
    </Card>
  );
};